import {
  CheckboxProps as ChakraCheckboxProps,
  Checkbox as ChakraCheckbox,
} from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';
import React, { useState } from 'react';
import { useField } from 'formik';

type CheckboxProps = ChakraCheckboxProps & { params?: string[] };

export const FormikCheckbox: React.FC<CheckboxProps> = ({
  params,
  children,
  ...props
}) => {
  const translate = useTranslate();
  const [field, meta, helpers] = useField(props.name);
  const [isChecked, setIsChecked] = useState(
    field.checked ?? meta.initialValue,
  );

  return (
    <ChakraCheckbox
      {...props}
      {...field}
      name={field.name}
      type="checkbox"
      isChecked={isChecked}
      onChange={() => {
        if (isChecked) {
          helpers.setValue(false);
          setIsChecked(false);
        } else {
          helpers.setValue(true);
          setIsChecked(true);
        }
      }}
      borderColor="#807a7a"
    >
      {translate(children, params)}
    </ChakraCheckbox>
  );
};
